export default {
  popup: {
    isActive: false,
  },
};
